import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import TasksPanelFull from './TasksPanelFull';
import TasksPanelNarrow from './TasksPanelNarrow';

const TasksPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: TasksPanelFull, narrow: TasksPanelNarrow }}
    onChange={onChange}
    width={620}
  />
);

export default TasksPanel;
